import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
export function BonusesSection() {
  return <section className="w-full bg-white px-5 py-12 sm:py-16" data-id="element-17" data-mp="gwx3kxxwuxbm">
      <div className="mx-auto max-w-[760px]" data-id="element-18" data-mp="vtfjgwgyi5h2">
        <h2 className="flex items-center justify-center gap-2.5 text-center text-[1.5rem] font-extrabold uppercase leading-[0.95] tracking-tight text-slate-950 sm:text-[1.9rem]" data-id="element-19" data-mp="vu7g8amai98x">
          <GiftIcon className="h-6 w-6 shrink-0 text-orange-700" aria-hidden="true" data-id="element-20" data-mp="14s9n36spfw44" />
          PLUS: 5 Strategic Bonuses Included
        </h2>

        <ol className="mt-7 space-y-3" data-id="element-21" data-mp="1ejnhx19po7qx">
          {bonuses.map(bonus => <li key={bonus.label} className="rounded-lg border-2 border-dashed border-orange-500/70 bg-slate-100 p-5" data-id="element-22" data-mp="19kkn09ng3hwo">
              <p className="text-[0.75rem] font-black uppercase tracking-[0.18em] text-orange-700" data-id="element-23" data-mp="1nkbxi0er6g5x">
                {bonus.label}
              </p>
              <h3 className="mt-1 text-[1rem] font-extrabold uppercase leading-tight tracking-tight text-slate-950 sm:text-[1.1rem]" data-id="element-24" data-mp="3pqtugmq1i1fw">
                {bonus.title}
              </h3>
              <p className="mt-1 text-[0.9rem] font-bold text-slate-800" data-id="element-25" data-mp="2lm4kzs4u8jg">
                {bonus.tagline}
              </p>
              <p className="mt-2 text-[0.95rem] leading-relaxed text-slate-950" data-id="element-26" data-mp="7kz2cfkjl00t">
                {bonus.description}
              </p>
              <ul className="mt-3 flex flex-wrap gap-1.5" data-id="element-27" data-mp="cja9ujnd6yfv">
                {bonus.highlights.map(item => <li key={item} className="rounded-md bg-white px-2.5 py-1 text-[0.85rem] font-semibold text-slate-950" data-id="element-28" data-mp="gjap26iafdnz">
                    {item}
                  </li>)}
              </ul>
              <p className="mt-3 text-[0.8rem] font-extrabold uppercase tracking-tight text-orange-700" data-id="element-29" data-mp="vbcndm4plylw">
                {bonus.footnote}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}